import { usePage } from "@inertiajs/react"
import { useEffect } from "react"
import { toast } from "sonner"
import type { SharedProps } from "@/types"

export default function FlashMessages() {
  const { flash } = usePage<SharedProps>().props

  useEffect(() => {
    if (flash?.notice) {
      toast.success(flash.notice)
    }
    if (flash?.alert) {
      toast.error(flash.alert)
    }
  }, [flash?.notice, flash?.alert])

  return null
}
